import { combineReducers } from 'redux';
import permission from '../screens/Permission/reducers';
import permissionSearch from '../screens/PermissionSearch/reducers';
import siteSetting from '../screens/SiteSetting/reducers';
export default combineReducers({
  permission,
  permissionSearch,
  siteSetting,
});



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanySpace/reducers/index.js
 **/